<script>
export default {
  name: "EditRequestRatioModal",
  props: {
    /*
     * モーダルの表示設定
     */
    enable: {
      type: Boolean,
      default: false
    },
    /*
     * 展開するリスト
     * @param resultList { Array }
     * @param resultList.recycle_disposer_disposal_method_id { Number } 処分場処理方法ID
     * @param resultList.disposer_name { String } 処分事業者名
     * @param resultList.disposer_location_name { String } 処分事業場名
     * @param resultList.recycle_disposer_disposal_method_name { String } 処分場処理方法名
     * @param resultList.request_ratio { Number } 依頼割合
     */
    resultList: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      workingList: null
    }
  },
  watch: {
    enable (value) {
      this.workingList = null;
      if (this.$refs.requestRatioValidation) {
        this.$refs.requestRatioValidation.reset();
      }
      if (value) {
        this.workingList = this.resultList
      }
    },
  },
  methods: {

    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClick () {
      this.$emit('close')
    },

    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClick () {
      this.$refs.requestRatioValidation.validate().then((valid) => {
        if (valid) {
          this.$emit('register', this.workingList)
        }
      })
    },
  },
}
</script>

<template>
  <v-dialog
    :value="enable"
    persistent
    scrollable
    width="700"
    @keydown.esc="closeButtonClick"
    @close="closeButtonClick"
  >
    <validation-observer ref="requestRatioValidation">
      <v-card flat>
        <v-toolbar flat dense>
          <v-toolbar-title>紐付いた処分場への依頼割合を設定</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text
          style="max-height: 50vh;overflow-y: auto;"
        >
          <v-simple-table
            v-if="workingList"
          >
            <thead>
            <tr>
              <th style="width: 65%">処分事業者<br />処分事業場</th>
              <th style="width: 30%">依頼割合</th>
              <th style="width: 5%" />
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in workingList" :key="index">
              <td>
                <div class="line-clamp one-clamp">{{ item.disposer_name }}</div>
                <div class="line-clamp one-clamp">{{ item.disposer_location_name }}</div>
                <div class="grey--text line-clamp one-clamp"><small>{{ item.recycle_disposer_disposal_method_name }}</small></div>
              </td>
              <td>
                <validation-provider
                  v-slot="{ errors }"
                  :vid="`request_ratio-${ item.key }`"
                  name="依頼割合"
                  :rules="{
                    required: true,
                    double: true,
                    min_value: 0.1,
                    max_value: 100,
                    quantityWithDecimal: { int_digits: 3, dec_digits: 1 },
                  }"
                >
                  <v-text-field
                    v-model="item.request_ratio"
                    :error-messages="errors"
                    dense
                    type="number"
                    reverse
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    class="recycle-input"
                  >
                    <template v-slot:prepend-inner>
                      <span class="mt-1 ml-2">&#37;</span>
                    </template>
                  </v-text-field>
                </validation-provider>
              </td>
              <td />
            </tr>
            </tbody>
          </v-simple-table>
          <validation-provider
            v-slot="{ errors: detailErrors }"
            name="リスト"
            :rules="{ requestRatioTotal: { targetList: workingList } }"
          >
            <div class="hidden">
              <v-input
                v-model="workingList"
                :error-messages="detailErrors"
                dense
                outlined
                readonly
                hide-details="auto"
              >
                <template v-slot:message>
                  <div class="ml-2">
                    <p v-for="(message, index) in detailErrors" :key="index">{{ message }}</p>
                  </div>
                </template>
              </v-input>
            </div>
          </validation-provider>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClick"
          >
            閉じる
          </v-btn>
          <v-btn
            color="primary"
            @click="registerButtonClick"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>

<style scoped lang="scss">

</style>
